import * as Yup from 'yup';
import messages from 'components/ChangePassewordModal/messages';
import { translate } from 'helpers/intl';

export default (props: any) =>
  Yup.object().shape({
    currentPassword: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),

    newPassword: Yup.string()
      .min(8, translate({ ...messages.passwordMsg }, props))
      .required(translate({ ...messages.requiredField }, props)),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref('newPassword')],
        translate({ ...messages.confirmPasswordError }, props),
      )
      .required(translate({ ...messages.requiredField }, props)),
  });
